import IconButton from '@alltrails/denali/components/IconButton';
import Play from '@alltrails/denali/icons/Play';
import { IconComponent } from '@alltrails/denali/components/Icon';
import { useIntl } from 'react-intl';
import styles from './PhotoTourButton.module.scss';

type PhotoTourButtonProps = {
  isMobile: boolean;
  onClick: () => void;
};

const PhotoTourButton = ({ isMobile, onClick }: PhotoTourButtonProps) => {
  const intl = useIntl();
  return (
    <div className={isMobile ? styles.mobilePhotoTourButton : ''}>
      <div className={styles.photoTourButtonContainer}>
        <IconButton
          icon={{ Component: Play as IconComponent }}
          onClick={onClick}
          testId="photo-tour-cta"
          title={intl.formatMessage({ defaultMessage: 'Photo tour' })}
          variant="elevated"
        />
      </div>
    </div>
  );
};

export default PhotoTourButton;
